export default {"src":"/_next/static/media/ic-instagram.5695f36a.svg","height":16,"width":16};